function Colgroup({ cols }) {
  const colTags = cols.map((colWidth, index) => (
    <col key={'col' + index} style={{ width: colWidth }} />
  ));

  return <colgroup>{colTags}</colgroup>;
}

export default Colgroup;
